(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["dd-days-to"] && !Shopify.designMode) return;
  try {
    (function () {
    function paint() {
      var nodes = document.querySelectorAll('[data-dd-days-to]');
      if (!nodes.length) return;
      var now = new Date();
      var today = Date.UTC(now.getFullYear(), now.getMonth(), now.getDate());
      nodes.forEach(function (el) {
        var p = (el.getAttribute('data-dd-days-to') || '').split('-');
        if (p.length !== 3) return;
        var target = Date.UTC(+p[0], +p[1] - 1, +p[2]);
        var d = Math.max(0, Math.round((target - today) / 86400000));
        el.textContent = el.getAttribute('data-unit') === 'short' ? String(d) : d + (d === 1 ? ' day' : ' days');
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', paint); else paint();
    document.addEventListener('shopify:section:load', paint);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dd-xmas-countdown"] && !Shopify.designMode) return;
  try {
    (function () {
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function tick() {
      document.querySelectorAll('[data-dd-xmas]').forEach(function (box) {
        var p = (box.getAttribute('data-dd-xmas') || '').split('-');
        if (p.length !== 3) return;
        var left = Math.max(0, Math.floor((new Date(+p[0], +p[1] - 1, +p[2], 0, 0, 0) - new Date()) / 1000));
        var v = { d: Math.floor(left / 86400), h: pad(Math.floor(left % 86400 / 3600)), m: pad(Math.floor(left % 3600 / 60)), s: pad(left % 60) };
        box.querySelectorAll('[data-u]').forEach(function (el) { var u = el.getAttribute('data-u'); if (el.textContent !== String(v[u])) el.textContent = v[u]; });
      });
    }
    function start() {
      if (!document.querySelector('[data-dd-xmas]')) return;
      tick();
      if (!window.__ddXmasTimer) window.__ddXmasTimer = setInterval(tick, 1000);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
    document.addEventListener('shopify:section:load', start);
  })();
  } catch(e) { console.error(e); }
})();

})();
